module.exports = __webpack_public_path__ + "img/OY.fedd0e71.png";